import { store } from '../redux/lib/configureStore.js';
import apiRequest from './redux/apiRequest.js';
import streamRequest from './redux/streamRequest.js';

export const action = (type, payload = {}, callback) => {
  store.dispatch({ type, payload });
  if (typeof callback === 'function') {
    callback(payload);
  }
};

export const get = (url, config = {}) => apiRequest('GET', url, config);
export const post = (url, config = {}) => apiRequest('POST', url, config);
export const put = (url, config = {}) => apiRequest('PUT', url, config);
export const patch = (url, config = {}) => apiRequest('PATCH', url, config);
export const del = (url, config = {}) => apiRequest('DELETE', url, config);
export const stream = (url, config = {}) => streamRequest(url, config);

export default { get, post, put, del, action, stream };
